<template>
  <div class="hold" style="padding: 0; margin-left: 0; margin-right: 0;">
     <div class="valign-center" v-if="loading">
      <div class="spinner">
        <broken-spinner color="#554971" :thickness="2" />
      </div>
    </div>
    <div v-else>
      <div class="w-200">
        <div class="d-flex flex-column justify-content-center text-white h-200 w-100 brandon">
          <div class="st">
              <h2 class="mt-1 job-header">
                {{ job.preferred_tutor_gender ? ucfirst(job.preferred_tutor_gender) : '' }}
                {{ (job.subjects && job.subjects.length > 1) ? 'Home Tutor' : job.subjects && job.subjects[0] && ucfirst(job.subjects[0].name) }}
                Needed at
                {{ job.location  && `${job.location.name},` }}
                {{ verified ? job.state && job.state.name : stateById((job.location && job.location.state_id) || 1) && stateById((job.location && job.location.state_id) || 1).name }}
                <svg v-if="verified" height="20px" class="svg-wrap2" viewBox="0 0 496 496.01461" width="20px" xmlns="http://www.w3.org/2000/svg"><title>Verified Job</title><path d="m455.882812 128.003906-60.800781-27.046875-27.070312-60.824219-66.167969 6.910157-53.832031-39.039063-53.863281 39.039063-66.136719-6.910157-27.050781 60.796876-60.824219 27.074218 6.914062 66.167969-39.039062 53.832031 39.039062 53.863282-6.914062 66.136718 60.800781 27.046875 27.074219 60.824219 66.167969-6.910156 53.832031 39.039062 53.863281-39.039062 66.136719 6.910156 27.046875-60.800781 60.824218-27.070313-6.914062-66.167968 39.042969-53.832032-39.042969-53.863281zm-255.871093 216-67.921875-67.921875 22.640625-22.558593 45.28125 45.199218 135.757812-135.757812 22.640625 22.636718zm0 0" fill="#8EB8E5"/><g fill="#8EB8E5"><path d="m494.492188 243.308594-37.25-51.386719 6.601562-63.109375c.359375-3.449219-1.539062-6.734375-4.707031-8.144531l-57.980469-25.800781-25.800781-57.984376c-1.417969-3.160156-4.699219-5.054687-8.144531-4.710937l-63.121094 6.597656-51.382813-37.246093c-2.800781-2.03125-6.589843-2.03125-9.390625 0l-51.386718 37.246093-63.117188-6.597656c-3.441406-.328125-6.710938 1.5625-8.144531 4.703125l-25.800781 57.984375-57.984376 25.808594c-3.164062 1.40625-5.0625 4.691406-4.703124 8.136719l6.597656 63.117187-37.246094 51.386719c-2.03125 2.800781-2.03125 6.589844 0 9.390625l37.246094 51.382812-6.597656 63.121094c-.363282 3.445313 1.535156 6.734375 4.703124 8.144531l57.984376 25.800782 25.800781 57.984374c1.425781 3.148438 4.699219 5.042969 8.144531 4.710938l63.117188-6.601562 51.386718 37.25c2.800782 2.03125 6.589844 2.03125 9.390625 0l51.382813-37.25 63.121094 6.601562c3.445312.347656 6.722656-1.546875 8.144531-4.703125l25.800781-57.984375 57.980469-25.808594c3.164062-1.410156 5.0625-4.691406 4.707031-8.136718l-6.601562-63.121094 37.25-51.382813c2.035156-2.800781 2.035156-6.597656 0-9.398437zm-52 53.863281c-1.160157 1.597656-1.6875 3.566406-1.480469 5.527344l6.304687 60.382812-55.480468 24.699219c-1.8125.796875-3.265626 2.242188-4.066407 4.054688l-24.679687 55.480468-60.398438-6.3125c-1.960937-.203125-3.925781.328125-5.519531 1.488282l-49.160156 35.632812-49.167969-35.632812c-1.363281-.996094-3.003906-1.53125-4.6875-1.527344-.28125 0-.5625 0-.800781.039062l-60.402344 6.3125-24.679687-55.480468c-.804688-1.8125-2.25-3.261719-4.0625-4.066407l-55.511719-24.6875 6.304687-60.382812c.203125-1.960938-.324218-3.929688-1.480468-5.527344l-35.632813-49.167969 35.632813-49.167968c1.15625-1.597657 1.683593-3.566407 1.480468-5.527344l-6.304687-60.386719 55.480469-24.695313c1.8125-.796874 3.261718-2.242187 4.0625-4.054687l24.679687-55.480469 60.402344 6.3125c1.957031.195313 3.921875-.335937 5.519531-1.488281l49.167969-35.632813 49.167969 35.632813c1.59375 1.15625 3.558593 1.683594 5.519531 1.488281l60.398437-6.3125 24.679688 55.480469c.804687 1.8125 2.253906 3.257813 4.066406 4.0625l55.480469 24.6875-6.304688 60.386719c-.207031 1.960937.320313 3.929687 1.480469 5.527344l35.628906 49.167968zm0 0"/><path d="m341.425781 157.308594c-3.125-3.125-8.1875-3.125-11.3125 0l-130.101562 130.101562-39.625-39.550781c-3.121094-3.113281-8.175781-3.113281-11.296875 0l-22.679688 22.542969c-1.503906 1.5-2.351562 3.539062-2.351562 5.664062s.847656 4.164063 2.351562 5.664063l67.921875 67.921875c3.121094 3.121094 8.1875 3.121094 11.3125 0l158.398438-158.402344c3.121093-3.121094 3.121093-8.1875 0-11.3125zm-141.414062 175.382812-56.601563-56.601562 11.3125-11.285156 39.640625 39.558593c3.121094 3.117188 8.179688 3.117188 11.304688 0l130.101562-130.089843 11.328125 11.328124zm0 0"/></g></svg>
                <svg v-else height="20px" class="AC" viewBox="0 0 496 496.01461" width="20px" xmlns="http://www.w3.org/2000/svg"><title>Unverified Job</title><path d="m455.882812 128.003906-60.800781-27.046875-27.070312-60.824219-66.167969 6.910157-53.832031-39.039063-53.863281 39.039063-66.136719-6.910157-27.050781 60.796876-60.824219 27.074218 6.914062 66.167969-39.039062 53.832031 39.039062 53.863282-6.914062 66.136718 60.800781 27.046875 27.074219 60.824219 66.167969-6.910156 53.832031 39.039062 53.863281-39.039062 66.136719 6.910156 27.046875-60.800781 60.824218-27.070313-6.914062-66.167968 39.042969-53.832032-39.042969-53.863281zm-255.871093 216-67.921875-67.921875 22.640625-22.558593 45.28125 45.199218 135.757812-135.757812 22.640625 22.636718zm0 0" fill="#D3D3D3"/><g fill="#D3D3D3"><path d="m494.492188 243.308594-37.25-51.386719 6.601562-63.109375c.359375-3.449219-1.539062-6.734375-4.707031-8.144531l-57.980469-25.800781-25.800781-57.984376c-1.417969-3.160156-4.699219-5.054687-8.144531-4.710937l-63.121094 6.597656-51.382813-37.246093c-2.800781-2.03125-6.589843-2.03125-9.390625 0l-51.386718 37.246093-63.117188-6.597656c-3.441406-.328125-6.710938 1.5625-8.144531 4.703125l-25.800781 57.984375-57.984376 25.808594c-3.164062 1.40625-5.0625 4.691406-4.703124 8.136719l6.597656 63.117187-37.246094 51.386719c-2.03125 2.800781-2.03125 6.589844 0 9.390625l37.246094 51.382812-6.597656 63.121094c-.363282 3.445313 1.535156 6.734375 4.703124 8.144531l57.984376 25.800782 25.800781 57.984374c1.425781 3.148438 4.699219 5.042969 8.144531 4.710938l63.117188-6.601562 51.386718 37.25c2.800782 2.03125 6.589844 2.03125 9.390625 0l51.382813-37.25 63.121094 6.601562c3.445312.347656 6.722656-1.546875 8.144531-4.703125l25.800781-57.984375 57.980469-25.808594c3.164062-1.410156 5.0625-4.691406 4.707031-8.136718l-6.601562-63.121094 37.25-51.382813c2.035156-2.800781 2.035156-6.597656 0-9.398437zm-52 53.863281c-1.160157 1.597656-1.6875 3.566406-1.480469 5.527344l6.304687 60.382812-55.480468 24.699219c-1.8125.796875-3.265626 2.242188-4.066407 4.054688l-24.679687 55.480468-60.398438-6.3125c-1.960937-.203125-3.925781.328125-5.519531 1.488282l-49.160156 35.632812-49.167969-35.632812c-1.363281-.996094-3.003906-1.53125-4.6875-1.527344-.28125 0-.5625 0-.800781.039062l-60.402344 6.3125-24.679687-55.480468c-.804688-1.8125-2.25-3.261719-4.0625-4.066407l-55.511719-24.6875 6.304687-60.382812c.203125-1.960938-.324218-3.929688-1.480468-5.527344l-35.632813-49.167969 35.632813-49.167968c1.15625-1.597657 1.683593-3.566407 1.480468-5.527344l-6.304687-60.386719 55.480469-24.695313c1.8125-.796874 3.261718-2.242187 4.0625-4.054687l24.679687-55.480469 60.402344 6.3125c1.957031.195313 3.921875-.335937 5.519531-1.488281l49.167969-35.632813 49.167969 35.632813c1.59375 1.15625 3.558593 1.683594 5.519531 1.488281l60.398437-6.3125 24.679688 55.480469c.804687 1.8125 2.253906 3.257813 4.066406 4.0625l55.480469 24.6875-6.304688 60.386719c-.207031 1.960937.320313 3.929687 1.480469 5.527344l35.628906 49.167968zm0 0"/><path d="m341.425781 157.308594c-3.125-3.125-8.1875-3.125-11.3125 0l-130.101562 130.101562-39.625-39.550781c-3.121094-3.113281-8.175781-3.113281-11.296875 0l-22.679688 22.542969c-1.503906 1.5-2.351562 3.539062-2.351562 5.664062s.847656 4.164063 2.351562 5.664063l67.921875 67.921875c3.121094 3.121094 8.1875 3.121094 11.3125 0l158.398438-158.402344c3.121093-3.121094 3.121093-8.1875 0-11.3125zm-141.414062 175.382812-56.601563-56.601562 11.3125-11.285156 39.640625 39.558593c3.121094 3.117188 8.179688 3.117188 11.304688 0l130.101562-130.089843 11.328125 11.328124zm0 0"/></g></svg>
                <!-- premium -->
                <span v-if="verified==false">
                  <span v-if="job.client_tutor_choice && JSON.parse(job.client_tutor_choice).selected_package == 1">
                    <svg height="20px" class="AP" viewBox="0 0 496 496.01461" width="20px" xmlns="http://www.w3.org/2000/svg"><title>Premium Job</title><path d="m455.882812 128.003906-60.800781-27.046875-27.070312-60.824219-66.167969 6.910157-53.832031-39.039063-53.863281 39.039063-66.136719-6.910157-27.050781 60.796876-60.824219 27.074218 6.914062 66.167969-39.039062 53.832031 39.039062 53.863282-6.914062 66.136718 60.800781 27.046875 27.074219 60.824219 66.167969-6.910156 53.832031 39.039062 53.863281-39.039062 66.136719 6.910156 27.046875-60.800781 60.824218-27.070313-6.914062-66.167968 39.042969-53.832032-39.042969-53.863281zm-255.871093 216-67.921875-67.921875 22.640625-22.558593 45.28125 45.199218 135.757812-135.757812 22.640625 22.636718zm0 0" fill="#32A300"/><g fill="#32A300"><path d="m494.492188 243.308594-37.25-51.386719 6.601562-63.109375c.359375-3.449219-1.539062-6.734375-4.707031-8.144531l-57.980469-25.800781-25.800781-57.984376c-1.417969-3.160156-4.699219-5.054687-8.144531-4.710937l-63.121094 6.597656-51.382813-37.246093c-2.800781-2.03125-6.589843-2.03125-9.390625 0l-51.386718 37.246093-63.117188-6.597656c-3.441406-.328125-6.710938 1.5625-8.144531 4.703125l-25.800781 57.984375-57.984376 25.808594c-3.164062 1.40625-5.0625 4.691406-4.703124 8.136719l6.597656 63.117187-37.246094 51.386719c-2.03125 2.800781-2.03125 6.589844 0 9.390625l37.246094 51.382812-6.597656 63.121094c-.363282 3.445313 1.535156 6.734375 4.703124 8.144531l57.984376 25.800782 25.800781 57.984374c1.425781 3.148438 4.699219 5.042969 8.144531 4.710938l63.117188-6.601562 51.386718 37.25c2.800782 2.03125 6.589844 2.03125 9.390625 0l51.382813-37.25 63.121094 6.601562c3.445312.347656 6.722656-1.546875 8.144531-4.703125l25.800781-57.984375 57.980469-25.808594c3.164062-1.410156 5.0625-4.691406 4.707031-8.136718l-6.601562-63.121094 37.25-51.382813c2.035156-2.800781 2.035156-6.597656 0-9.398437zm-52 53.863281c-1.160157 1.597656-1.6875 3.566406-1.480469 5.527344l6.304687 60.382812-55.480468 24.699219c-1.8125.796875-3.265626 2.242188-4.066407 4.054688l-24.679687 55.480468-60.398438-6.3125c-1.960937-.203125-3.925781.328125-5.519531 1.488282l-49.160156 35.632812-49.167969-35.632812c-1.363281-.996094-3.003906-1.53125-4.6875-1.527344-.28125 0-.5625 0-.800781.039062l-60.402344 6.3125-24.679687-55.480468c-.804688-1.8125-2.25-3.261719-4.0625-4.066407l-55.511719-24.6875 6.304687-60.382812c.203125-1.960938-.324218-3.929688-1.480468-5.527344l-35.632813-49.167969 35.632813-49.167968c1.15625-1.597657 1.683593-3.566407 1.480468-5.527344l-6.304687-60.386719 55.480469-24.695313c1.8125-.796874 3.261718-2.242187 4.0625-4.054687l24.679687-55.480469 60.402344 6.3125c1.957031.195313 3.921875-.335937 5.519531-1.488281l49.167969-35.632813 49.167969 35.632813c1.59375 1.15625 3.558593 1.683594 5.519531 1.488281l60.398437-6.3125 24.679688 55.480469c.804687 1.8125 2.253906 3.257813 4.066406 4.0625l55.480469 24.6875-6.304688 60.386719c-.207031 1.960937.320313 3.929687 1.480469 5.527344l35.628906 49.167968zm0 0"/><path d="m341.425781 157.308594c-3.125-3.125-8.1875-3.125-11.3125 0l-130.101562 130.101562-39.625-39.550781c-3.121094-3.113281-8.175781-3.113281-11.296875 0l-22.679688 22.542969c-1.503906 1.5-2.351562 3.539062-2.351562 5.664062s.847656 4.164063 2.351562 5.664063l67.921875 67.921875c3.121094 3.121094 8.1875 3.121094 11.3125 0l158.398438-158.402344c3.121093-3.121094 3.121093-8.1875 0-11.3125zm-141.414062 175.382812-56.601563-56.601562 11.3125-11.285156 39.640625 39.558593c3.121094 3.117188 8.179688 3.117188 11.304688 0l130.101562-130.089843 11.328125 11.328124zm0 0"/></g></svg>
                  </span>
                  <!-- lite -->
                  <span v-else-if="job.client_tutor_choice && JSON.parse(job.client_tutor_choice).selected_package == 2">
                    <svg height="20px" class="AL" viewBox="0 0 496 496.01461" width="20px" xmlns="http://www.w3.org/2000/svg"><title>Lite Job</title><path d="m455.882812 128.003906-60.800781-27.046875-27.070312-60.824219-66.167969 6.910157-53.832031-39.039063-53.863281 39.039063-66.136719-6.910157-27.050781 60.796876-60.824219 27.074218 6.914062 66.167969-39.039062 53.832031 39.039062 53.863282-6.914062 66.136718 60.800781 27.046875 27.074219 60.824219 66.167969-6.910156 53.832031 39.039062 53.863281-39.039062 66.136719 6.910156 27.046875-60.800781 60.824218-27.070313-6.914062-66.167968 39.042969-53.832032-39.042969-53.863281zm-255.871093 216-67.921875-67.921875 22.640625-22.558593 45.28125 45.199218 135.757812-135.757812 22.640625 22.636718zm0 0" fill="#E0D700"/><g fill="#E0D700"><path d="m494.492188 243.308594-37.25-51.386719 6.601562-63.109375c.359375-3.449219-1.539062-6.734375-4.707031-8.144531l-57.980469-25.800781-25.800781-57.984376c-1.417969-3.160156-4.699219-5.054687-8.144531-4.710937l-63.121094 6.597656-51.382813-37.246093c-2.800781-2.03125-6.589843-2.03125-9.390625 0l-51.386718 37.246093-63.117188-6.597656c-3.441406-.328125-6.710938 1.5625-8.144531 4.703125l-25.800781 57.984375-57.984376 25.808594c-3.164062 1.40625-5.0625 4.691406-4.703124 8.136719l6.597656 63.117187-37.246094 51.386719c-2.03125 2.800781-2.03125 6.589844 0 9.390625l37.246094 51.382812-6.597656 63.121094c-.363282 3.445313 1.535156 6.734375 4.703124 8.144531l57.984376 25.800782 25.800781 57.984374c1.425781 3.148438 4.699219 5.042969 8.144531 4.710938l63.117188-6.601562 51.386718 37.25c2.800782 2.03125 6.589844 2.03125 9.390625 0l51.382813-37.25 63.121094 6.601562c3.445312.347656 6.722656-1.546875 8.144531-4.703125l25.800781-57.984375 57.980469-25.808594c3.164062-1.410156 5.0625-4.691406 4.707031-8.136718l-6.601562-63.121094 37.25-51.382813c2.035156-2.800781 2.035156-6.597656 0-9.398437zm-52 53.863281c-1.160157 1.597656-1.6875 3.566406-1.480469 5.527344l6.304687 60.382812-55.480468 24.699219c-1.8125.796875-3.265626 2.242188-4.066407 4.054688l-24.679687 55.480468-60.398438-6.3125c-1.960937-.203125-3.925781.328125-5.519531 1.488282l-49.160156 35.632812-49.167969-35.632812c-1.363281-.996094-3.003906-1.53125-4.6875-1.527344-.28125 0-.5625 0-.800781.039062l-60.402344 6.3125-24.679687-55.480468c-.804688-1.8125-2.25-3.261719-4.0625-4.066407l-55.511719-24.6875 6.304687-60.382812c.203125-1.960938-.324218-3.929688-1.480468-5.527344l-35.632813-49.167969 35.632813-49.167968c1.15625-1.597657 1.683593-3.566407 1.480468-5.527344l-6.304687-60.386719 55.480469-24.695313c1.8125-.796874 3.261718-2.242187 4.0625-4.054687l24.679687-55.480469 60.402344 6.3125c1.957031.195313 3.921875-.335937 5.519531-1.488281l49.167969-35.632813 49.167969 35.632813c1.59375 1.15625 3.558593 1.683594 5.519531 1.488281l60.398437-6.3125 24.679688 55.480469c.804687 1.8125 2.253906 3.257813 4.066406 4.0625l55.480469 24.6875-6.304688 60.386719c-.207031 1.960937.320313 3.929687 1.480469 5.527344l35.628906 49.167968zm0 0"/><path d="m341.425781 157.308594c-3.125-3.125-8.1875-3.125-11.3125 0l-130.101562 130.101562-39.625-39.550781c-3.121094-3.113281-8.175781-3.113281-11.296875 0l-22.679688 22.542969c-1.503906 1.5-2.351562 3.539062-2.351562 5.664062s.847656 4.164063 2.351562 5.664063l67.921875 67.921875c3.121094 3.121094 8.1875 3.121094 11.3125 0l158.398438-158.402344c3.121093-3.121094 3.121093-8.1875 0-11.3125zm-141.414062 175.382812-56.601563-56.601562 11.3125-11.285156 39.640625 39.558593c3.121094 3.117188 8.179688 3.117188 11.304688 0l130.101562-130.089843 11.328125 11.328124zm0 0"/></g></svg>
                  </span>
                  <!-- starter -->
                  <span v-else>
                    <svg height="20px" class="AS" viewBox="0 0 496 496.01461" width="20px" xmlns="http://www.w3.org/2000/svg"><title>Starter Job</title><path d="m455.882812 128.003906-60.800781-27.046875-27.070312-60.824219-66.167969 6.910157-53.832031-39.039063-53.863281 39.039063-66.136719-6.910157-27.050781 60.796876-60.824219 27.074218 6.914062 66.167969-39.039062 53.832031 39.039062 53.863282-6.914062 66.136718 60.800781 27.046875 27.074219 60.824219 66.167969-6.910156 53.832031 39.039062 53.863281-39.039062 66.136719 6.910156 27.046875-60.800781 60.824218-27.070313-6.914062-66.167968 39.042969-53.832032-39.042969-53.863281zm-255.871093 216-67.921875-67.921875 22.640625-22.558593 45.28125 45.199218 135.757812-135.757812 22.640625 22.636718zm0 0" fill="#AC133C"/><g fill="#AC133C"><path d="m494.492188 243.308594-37.25-51.386719 6.601562-63.109375c.359375-3.449219-1.539062-6.734375-4.707031-8.144531l-57.980469-25.800781-25.800781-57.984376c-1.417969-3.160156-4.699219-5.054687-8.144531-4.710937l-63.121094 6.597656-51.382813-37.246093c-2.800781-2.03125-6.589843-2.03125-9.390625 0l-51.386718 37.246093-63.117188-6.597656c-3.441406-.328125-6.710938 1.5625-8.144531 4.703125l-25.800781 57.984375-57.984376 25.808594c-3.164062 1.40625-5.0625 4.691406-4.703124 8.136719l6.597656 63.117187-37.246094 51.386719c-2.03125 2.800781-2.03125 6.589844 0 9.390625l37.246094 51.382812-6.597656 63.121094c-.363282 3.445313 1.535156 6.734375 4.703124 8.144531l57.984376 25.800782 25.800781 57.984374c1.425781 3.148438 4.699219 5.042969 8.144531 4.710938l63.117188-6.601562 51.386718 37.25c2.800782 2.03125 6.589844 2.03125 9.390625 0l51.382813-37.25 63.121094 6.601562c3.445312.347656 6.722656-1.546875 8.144531-4.703125l25.800781-57.984375 57.980469-25.808594c3.164062-1.410156 5.0625-4.691406 4.707031-8.136718l-6.601562-63.121094 37.25-51.382813c2.035156-2.800781 2.035156-6.597656 0-9.398437zm-52 53.863281c-1.160157 1.597656-1.6875 3.566406-1.480469 5.527344l6.304687 60.382812-55.480468 24.699219c-1.8125.796875-3.265626 2.242188-4.066407 4.054688l-24.679687 55.480468-60.398438-6.3125c-1.960937-.203125-3.925781.328125-5.519531 1.488282l-49.160156 35.632812-49.167969-35.632812c-1.363281-.996094-3.003906-1.53125-4.6875-1.527344-.28125 0-.5625 0-.800781.039062l-60.402344 6.3125-24.679687-55.480468c-.804688-1.8125-2.25-3.261719-4.0625-4.066407l-55.511719-24.6875 6.304687-60.382812c.203125-1.960938-.324218-3.929688-1.480468-5.527344l-35.632813-49.167969 35.632813-49.167968c1.15625-1.597657 1.683593-3.566407 1.480468-5.527344l-6.304687-60.386719 55.480469-24.695313c1.8125-.796874 3.261718-2.242187 4.0625-4.054687l24.679687-55.480469 60.402344 6.3125c1.957031.195313 3.921875-.335937 5.519531-1.488281l49.167969-35.632813 49.167969 35.632813c1.59375 1.15625 3.558593 1.683594 5.519531 1.488281l60.398437-6.3125 24.679688 55.480469c.804687 1.8125 2.253906 3.257813 4.066406 4.0625l55.480469 24.6875-6.304688 60.386719c-.207031 1.960937.320313 3.929687 1.480469 5.527344l35.628906 49.167968zm0 0"/><path d="m341.425781 157.308594c-3.125-3.125-8.1875-3.125-11.3125 0l-130.101562 130.101562-39.625-39.550781c-3.121094-3.113281-8.175781-3.113281-11.296875 0l-22.679688 22.542969c-1.503906 1.5-2.351562 3.539062-2.351562 5.664062s.847656 4.164063 2.351562 5.664063l67.921875 67.921875c3.121094 3.121094 8.1875 3.121094 11.3125 0l158.398438-158.402344c3.121093-3.121094 3.121093-8.1875 0-11.3125zm-141.414062 175.382812-56.601563-56.601562 11.3125-11.285156 39.640625 39.558593c3.121094 3.117188 8.179688 3.117188 11.304688 0l130.101562-130.089843 11.328125 11.328124zm0 0"/></g></svg>
                  </span>
                </span>
                <span v-else>
                  <!-- package section -->
                  <span v-if="job.package == 1">
                    <svg height="20px" class="AP" viewBox="0 0 496 496.01461" width="20px" xmlns="http://www.w3.org/2000/svg"><title>Premium Job</title><path d="m455.882812 128.003906-60.800781-27.046875-27.070312-60.824219-66.167969 6.910157-53.832031-39.039063-53.863281 39.039063-66.136719-6.910157-27.050781 60.796876-60.824219 27.074218 6.914062 66.167969-39.039062 53.832031 39.039062 53.863282-6.914062 66.136718 60.800781 27.046875 27.074219 60.824219 66.167969-6.910156 53.832031 39.039062 53.863281-39.039062 66.136719 6.910156 27.046875-60.800781 60.824218-27.070313-6.914062-66.167968 39.042969-53.832032-39.042969-53.863281zm-255.871093 216-67.921875-67.921875 22.640625-22.558593 45.28125 45.199218 135.757812-135.757812 22.640625 22.636718zm0 0" fill="#32A300"/><g fill="#32A300"><path d="m494.492188 243.308594-37.25-51.386719 6.601562-63.109375c.359375-3.449219-1.539062-6.734375-4.707031-8.144531l-57.980469-25.800781-25.800781-57.984376c-1.417969-3.160156-4.699219-5.054687-8.144531-4.710937l-63.121094 6.597656-51.382813-37.246093c-2.800781-2.03125-6.589843-2.03125-9.390625 0l-51.386718 37.246093-63.117188-6.597656c-3.441406-.328125-6.710938 1.5625-8.144531 4.703125l-25.800781 57.984375-57.984376 25.808594c-3.164062 1.40625-5.0625 4.691406-4.703124 8.136719l6.597656 63.117187-37.246094 51.386719c-2.03125 2.800781-2.03125 6.589844 0 9.390625l37.246094 51.382812-6.597656 63.121094c-.363282 3.445313 1.535156 6.734375 4.703124 8.144531l57.984376 25.800782 25.800781 57.984374c1.425781 3.148438 4.699219 5.042969 8.144531 4.710938l63.117188-6.601562 51.386718 37.25c2.800782 2.03125 6.589844 2.03125 9.390625 0l51.382813-37.25 63.121094 6.601562c3.445312.347656 6.722656-1.546875 8.144531-4.703125l25.800781-57.984375 57.980469-25.808594c3.164062-1.410156 5.0625-4.691406 4.707031-8.136718l-6.601562-63.121094 37.25-51.382813c2.035156-2.800781 2.035156-6.597656 0-9.398437zm-52 53.863281c-1.160157 1.597656-1.6875 3.566406-1.480469 5.527344l6.304687 60.382812-55.480468 24.699219c-1.8125.796875-3.265626 2.242188-4.066407 4.054688l-24.679687 55.480468-60.398438-6.3125c-1.960937-.203125-3.925781.328125-5.519531 1.488282l-49.160156 35.632812-49.167969-35.632812c-1.363281-.996094-3.003906-1.53125-4.6875-1.527344-.28125 0-.5625 0-.800781.039062l-60.402344 6.3125-24.679687-55.480468c-.804688-1.8125-2.25-3.261719-4.0625-4.066407l-55.511719-24.6875 6.304687-60.382812c.203125-1.960938-.324218-3.929688-1.480468-5.527344l-35.632813-49.167969 35.632813-49.167968c1.15625-1.597657 1.683593-3.566407 1.480468-5.527344l-6.304687-60.386719 55.480469-24.695313c1.8125-.796874 3.261718-2.242187 4.0625-4.054687l24.679687-55.480469 60.402344 6.3125c1.957031.195313 3.921875-.335937 5.519531-1.488281l49.167969-35.632813 49.167969 35.632813c1.59375 1.15625 3.558593 1.683594 5.519531 1.488281l60.398437-6.3125 24.679688 55.480469c.804687 1.8125 2.253906 3.257813 4.066406 4.0625l55.480469 24.6875-6.304688 60.386719c-.207031 1.960937.320313 3.929687 1.480469 5.527344l35.628906 49.167968zm0 0"/><path d="m341.425781 157.308594c-3.125-3.125-8.1875-3.125-11.3125 0l-130.101562 130.101562-39.625-39.550781c-3.121094-3.113281-8.175781-3.113281-11.296875 0l-22.679688 22.542969c-1.503906 1.5-2.351562 3.539062-2.351562 5.664062s.847656 4.164063 2.351562 5.664063l67.921875 67.921875c3.121094 3.121094 8.1875 3.121094 11.3125 0l158.398438-158.402344c3.121093-3.121094 3.121093-8.1875 0-11.3125zm-141.414062 175.382812-56.601563-56.601562 11.3125-11.285156 39.640625 39.558593c3.121094 3.117188 8.179688 3.117188 11.304688 0l130.101562-130.089843 11.328125 11.328124zm0 0"/></g></svg>
                  </span>
                  <span v-else-if="job.package == 2">
                    <svg height="20px" class="AL" viewBox="0 0 496 496.01461" width="20px" xmlns="http://www.w3.org/2000/svg"><title>Lite Job</title><path d="m455.882812 128.003906-60.800781-27.046875-27.070312-60.824219-66.167969 6.910157-53.832031-39.039063-53.863281 39.039063-66.136719-6.910157-27.050781 60.796876-60.824219 27.074218 6.914062 66.167969-39.039062 53.832031 39.039062 53.863282-6.914062 66.136718 60.800781 27.046875 27.074219 60.824219 66.167969-6.910156 53.832031 39.039062 53.863281-39.039062 66.136719 6.910156 27.046875-60.800781 60.824218-27.070313-6.914062-66.167968 39.042969-53.832032-39.042969-53.863281zm-255.871093 216-67.921875-67.921875 22.640625-22.558593 45.28125 45.199218 135.757812-135.757812 22.640625 22.636718zm0 0" fill="#E0D700"/><g fill="#E0D700"><path d="m494.492188 243.308594-37.25-51.386719 6.601562-63.109375c.359375-3.449219-1.539062-6.734375-4.707031-8.144531l-57.980469-25.800781-25.800781-57.984376c-1.417969-3.160156-4.699219-5.054687-8.144531-4.710937l-63.121094 6.597656-51.382813-37.246093c-2.800781-2.03125-6.589843-2.03125-9.390625 0l-51.386718 37.246093-63.117188-6.597656c-3.441406-.328125-6.710938 1.5625-8.144531 4.703125l-25.800781 57.984375-57.984376 25.808594c-3.164062 1.40625-5.0625 4.691406-4.703124 8.136719l6.597656 63.117187-37.246094 51.386719c-2.03125 2.800781-2.03125 6.589844 0 9.390625l37.246094 51.382812-6.597656 63.121094c-.363282 3.445313 1.535156 6.734375 4.703124 8.144531l57.984376 25.800782 25.800781 57.984374c1.425781 3.148438 4.699219 5.042969 8.144531 4.710938l63.117188-6.601562 51.386718 37.25c2.800782 2.03125 6.589844 2.03125 9.390625 0l51.382813-37.25 63.121094 6.601562c3.445312.347656 6.722656-1.546875 8.144531-4.703125l25.800781-57.984375 57.980469-25.808594c3.164062-1.410156 5.0625-4.691406 4.707031-8.136718l-6.601562-63.121094 37.25-51.382813c2.035156-2.800781 2.035156-6.597656 0-9.398437zm-52 53.863281c-1.160157 1.597656-1.6875 3.566406-1.480469 5.527344l6.304687 60.382812-55.480468 24.699219c-1.8125.796875-3.265626 2.242188-4.066407 4.054688l-24.679687 55.480468-60.398438-6.3125c-1.960937-.203125-3.925781.328125-5.519531 1.488282l-49.160156 35.632812-49.167969-35.632812c-1.363281-.996094-3.003906-1.53125-4.6875-1.527344-.28125 0-.5625 0-.800781.039062l-60.402344 6.3125-24.679687-55.480468c-.804688-1.8125-2.25-3.261719-4.0625-4.066407l-55.511719-24.6875 6.304687-60.382812c.203125-1.960938-.324218-3.929688-1.480468-5.527344l-35.632813-49.167969 35.632813-49.167968c1.15625-1.597657 1.683593-3.566407 1.480468-5.527344l-6.304687-60.386719 55.480469-24.695313c1.8125-.796874 3.261718-2.242187 4.0625-4.054687l24.679687-55.480469 60.402344 6.3125c1.957031.195313 3.921875-.335937 5.519531-1.488281l49.167969-35.632813 49.167969 35.632813c1.59375 1.15625 3.558593 1.683594 5.519531 1.488281l60.398437-6.3125 24.679688 55.480469c.804687 1.8125 2.253906 3.257813 4.066406 4.0625l55.480469 24.6875-6.304688 60.386719c-.207031 1.960937.320313 3.929687 1.480469 5.527344l35.628906 49.167968zm0 0"/><path d="m341.425781 157.308594c-3.125-3.125-8.1875-3.125-11.3125 0l-130.101562 130.101562-39.625-39.550781c-3.121094-3.113281-8.175781-3.113281-11.296875 0l-22.679688 22.542969c-1.503906 1.5-2.351562 3.539062-2.351562 5.664062s.847656 4.164063 2.351562 5.664063l67.921875 67.921875c3.121094 3.121094 8.1875 3.121094 11.3125 0l158.398438-158.402344c3.121093-3.121094 3.121093-8.1875 0-11.3125zm-141.414062 175.382812-56.601563-56.601562 11.3125-11.285156 39.640625 39.558593c3.121094 3.117188 8.179688 3.117188 11.304688 0l130.101562-130.089843 11.328125 11.328124zm0 0"/></g></svg>
                  </span>
                  <span v-else>
                    <svg height="20px" class="AS" viewBox="0 0 496 496.01461" width="20px" xmlns="http://www.w3.org/2000/svg"><title>Starter Job</title><path d="m455.882812 128.003906-60.800781-27.046875-27.070312-60.824219-66.167969 6.910157-53.832031-39.039063-53.863281 39.039063-66.136719-6.910157-27.050781 60.796876-60.824219 27.074218 6.914062 66.167969-39.039062 53.832031 39.039062 53.863282-6.914062 66.136718 60.800781 27.046875 27.074219 60.824219 66.167969-6.910156 53.832031 39.039062 53.863281-39.039062 66.136719 6.910156 27.046875-60.800781 60.824218-27.070313-6.914062-66.167968 39.042969-53.832032-39.042969-53.863281zm-255.871093 216-67.921875-67.921875 22.640625-22.558593 45.28125 45.199218 135.757812-135.757812 22.640625 22.636718zm0 0" fill="#AC133C"/><g fill="#AC133C"><path d="m494.492188 243.308594-37.25-51.386719 6.601562-63.109375c.359375-3.449219-1.539062-6.734375-4.707031-8.144531l-57.980469-25.800781-25.800781-57.984376c-1.417969-3.160156-4.699219-5.054687-8.144531-4.710937l-63.121094 6.597656-51.382813-37.246093c-2.800781-2.03125-6.589843-2.03125-9.390625 0l-51.386718 37.246093-63.117188-6.597656c-3.441406-.328125-6.710938 1.5625-8.144531 4.703125l-25.800781 57.984375-57.984376 25.808594c-3.164062 1.40625-5.0625 4.691406-4.703124 8.136719l6.597656 63.117187-37.246094 51.386719c-2.03125 2.800781-2.03125 6.589844 0 9.390625l37.246094 51.382812-6.597656 63.121094c-.363282 3.445313 1.535156 6.734375 4.703124 8.144531l57.984376 25.800782 25.800781 57.984374c1.425781 3.148438 4.699219 5.042969 8.144531 4.710938l63.117188-6.601562 51.386718 37.25c2.800782 2.03125 6.589844 2.03125 9.390625 0l51.382813-37.25 63.121094 6.601562c3.445312.347656 6.722656-1.546875 8.144531-4.703125l25.800781-57.984375 57.980469-25.808594c3.164062-1.410156 5.0625-4.691406 4.707031-8.136718l-6.601562-63.121094 37.25-51.382813c2.035156-2.800781 2.035156-6.597656 0-9.398437zm-52 53.863281c-1.160157 1.597656-1.6875 3.566406-1.480469 5.527344l6.304687 60.382812-55.480468 24.699219c-1.8125.796875-3.265626 2.242188-4.066407 4.054688l-24.679687 55.480468-60.398438-6.3125c-1.960937-.203125-3.925781.328125-5.519531 1.488282l-49.160156 35.632812-49.167969-35.632812c-1.363281-.996094-3.003906-1.53125-4.6875-1.527344-.28125 0-.5625 0-.800781.039062l-60.402344 6.3125-24.679687-55.480468c-.804688-1.8125-2.25-3.261719-4.0625-4.066407l-55.511719-24.6875 6.304687-60.382812c.203125-1.960938-.324218-3.929688-1.480468-5.527344l-35.632813-49.167969 35.632813-49.167968c1.15625-1.597657 1.683593-3.566407 1.480468-5.527344l-6.304687-60.386719 55.480469-24.695313c1.8125-.796874 3.261718-2.242187 4.0625-4.054687l24.679687-55.480469 60.402344 6.3125c1.957031.195313 3.921875-.335937 5.519531-1.488281l49.167969-35.632813 49.167969 35.632813c1.59375 1.15625 3.558593 1.683594 5.519531 1.488281l60.398437-6.3125 24.679688 55.480469c.804687 1.8125 2.253906 3.257813 4.066406 4.0625l55.480469 24.6875-6.304688 60.386719c-.207031 1.960937.320313 3.929687 1.480469 5.527344l35.628906 49.167968zm0 0"/><path d="m341.425781 157.308594c-3.125-3.125-8.1875-3.125-11.3125 0l-130.101562 130.101562-39.625-39.550781c-3.121094-3.113281-8.175781-3.113281-11.296875 0l-22.679688 22.542969c-1.503906 1.5-2.351562 3.539062-2.351562 5.664062s.847656 4.164063 2.351562 5.664063l67.921875 67.921875c3.121094 3.121094 8.1875 3.121094 11.3125 0l158.398438-158.402344c3.121093-3.121094 3.121093-8.1875 0-11.3125zm-141.414062 175.382812-56.601563-56.601562 11.3125-11.285156 39.640625 39.558593c3.121094 3.117188 8.179688 3.117188 11.304688 0l130.101562-130.089843 11.328125 11.328124zm0 0"/></g></svg>
                  </span>
                </span>
              </h2>

              <h6 class="float-left o-6"><i class="fa fa-clock"> </i> Posted: {{ m(job.updated_at).format('dddd, D MMMM YYYY hh:mma') }}</h6>
              <button class="float-right btn-amount">
                <small>Earning</small><br>
                <span style="font-size: 20px" class="naira">&#8358;
                  <span v-if="verified"> {{number_format(job.monthly_tutoring_fee,2)}} </span>
                  <span v-else>
                    <span v-if="job.cs_status_id == 8 && !isNaN(job.meta && job.meta.budget_amount) || job.cs_status_id == 2 && !isNaN(job.meta && job.meta.budget_amount) || job.cs_status_id == 11 && !isNaN(job.meta && job.meta.budget_amount)">{{number_format(job.meta.budget_amount,2)}}</span>
                    <span v-else> {{number_format(job.amount, 2)}} </span>
                  </span>
                </span>
              </button>
          </div>
          <div v-if="verified" class="pl-5 ml-3">
              <!-- package section -->
              <!-- premium -->
              <em v-if="job.package == 1" style="font-size:11px"><b>Premium Job</b> - More than 5 years of teaching experience, Test scores more than 70% and great tutor profile.</em>
              <!-- lite -->
              <em v-else-if="job.package == 2" style="font-size:11px"><b>Lite Job</b>- 3-5 years of teaching experience, Test scores 65-70% and great tutor profile.</em>
              <!-- starter -->
              <em v-else style="font-size:11px"><b>Starter Job</b> - Less than 3 years of teaching experience, Test scores 60%-64% and great tutor profile.</em>
          </div>
          <div v-else class="pl-5 ml-3">
            <!-- premium -->
            <em v-if="job.client_tutor_choice && JSON.parse(job.client_tutor_choice).selected_package == 1" style="font-size:11px">
              <b>Premium Job</b> - More than 5 years of teaching experience, Test scores more than 70% and great tutor profile.
            </em>
            <!-- lite -->
            <em v-else-if="job.client_tutor_choice && JSON.parse(job.client_tutor_choice).selected_package == 2" style="font-size:11px">
              <b>Lite Job</b>- 3-5 years of teaching experience, Test scores 65-70% and great tutor profile.
            </em>
            <!-- starter -->
            <em v-else style="font-size:11px">
              <b>Starter Job</b> - Less than 3 years of teaching experience, Test scores 60%-64% and great tutor profile.
            </em>
          </div>
        </div>
      </div>
      <div class="container-fluid bg-light p-5">
        <div class="container">
          <div class="row">
            <div class="col-sm-12 col-lg-8">
              <div class="card job-content">
                <div class="row">
                  <div class="col-sm-12 col-lg-12 mb-3">
                    <div style="float: left;">
                      <small>Intended Start Date</small><br>
                      <button class="btn btn-outline btn-date o-6" id="butee" style="color: black;">
                        <i class="zmdi zmdi-calendar"></i>
                        {{ job.intended_start_date ? mnt(job.intended_start_date) : 'Pending'}}
                      </button>
                    </div>
                    <div class="float-right shift-sf">
                      <small>Job Status </small><br>
                      <button class="btn btn-outline btn-default btn-date hoverableslots" id="butee">
                        <b style="color: blue" v-if="!job.hasOwnProperty('slot')">Pending</b>
                        <b style="color: green" v-else-if="job.slot > 0">Ongoing!</b>
                        <b style="color: red" v-else>Closed!</b>
                        <span id="slotsLeft" v-if="job.slot && job.slot > 0"><b>{{job.slot}}&nbsp;</b> {{job.slot == 1 ? 'slot' : 'slots' }} left</span>
                      </button><br>
                    </div>
                  </div>
                  <hr>
                  <div class="col-sm-12 col-lg-12 job-desc">
                    <div class="row">
                      <div class="col-sm-12 col-lg-6">
                        <h6 class="mid-opacity mb-2 bold">Lesson Remarks</h6>
                          <span v-if="verified">{{ job.remark }}</span>
                          <div class="mt-2" v-for="(l, i) of job.learners" :key="i +1" v-else>
                            <small>Learner  {{ i + 1 }} </small><br>
                            <span>{{(l.details && l.details.about_learner) ? l.details.about_learner : 'Not set' }}</span>
                          </div>
                        <br>
                      </div>
                      <div class="col-sm-12 col-lg-6">
                        <h6 class="mid-opacity mb-2 bold">Days and Time</h6>
                        <span v-if="!verified">Pending</span>
                        <fragment v-else v-for="d of job.days" :key="d.id">
                          {{ d.name }}: {{ `${d.time.start} - ${d.time.end}` }} <br>
                        </fragment>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-12 col-lg-12 mt-3 job-desc">
                    <h6 class="green-text mb-3">Lesson Details</h6>
                    <div class="row">
                      <div class="col-sm-12 col-lg-6">
                        <span>
                          <h6 class="mid-opacity mb-2 bold">Student Information</h6>
                          <fragment v-for="l of job.learners" :key="l.id">
                            <div class="student_block" >
                              Student Level: {{ l.school_class && l.school_class.name || 'N/A' }}<br>
                              Student's Gender: {{ l.gender || 'N/A'}}<br>
                              Subjects Needed:<br>
                              <ul>
                                <li v-for="s of l.subjects" :key="s.id">{{ s.name }}</li>
                              </ul>
                            </div>
                            <hr>
                          </fragment>
                        </span>
                      </div>

                      <div class="col-sm-12 col-lg-6">
                        <h6 class="mb-2 mid-opacity bold">Lesson Information</h6>
                        Earning: &#8358;{{ verified ? number_format(job.monthly_tutoring_fee, 2) : number_format(job.amount, 2) }} for 1 month<br>
                        Preferred Tutor Gender:  {{ job.preferred_tutor_gender ? ucfirst(job.preferred_tutor_gender) : 'N/A' }}<br>
                        Cycle Length: {{ job.weeks_per_cycle + (job.weeks_per_cycle > 1 ? 'weeks' : 'week') || 'N/A' }} <br>
                        Venue: Client's Location<br>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-12 col-lg-12 mt-5">
                    <div class="row align-items-center">
                      <div class="col-sm-12 col-md-4 mapcontain">
                        <div class="mapbox" id="mapbox" ref="map"></div>
                      </div>
                      <div class="col-sm-12 col-lg-8 pt-2 pb-4">
                        <div class="ontop" v-show="checking">
                          <div class="spinner">
                            <broken-spinner color="#554971" :thickness="2" />
                          </div>
                        </div>
                        <h5 style="font-family: 'Montserrat'; text-align: center; padding: 15px;">Determine how far this place is from your address. <br><b id="mapkilometer">{{distanceText}}</b></h5>
                        <div class="mapactions">
                          <button class="map-button btn" @click="useGps">
                            <img src="./icon.svg" alt="">
                            Current Location
                          </button>
                          OR
                          <input type="text" id="autocomplete" ref="autocomplete" class="mapinput" placeholder="Find Address">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-sm-12 col-lg-4">
              <div class="card share-job" style="text-align: justify;">
                <b>Know someone fit for this Job?</b>
                <span style="width: 200px; font-size: 14px; padding-top: 10px;">
                  Share job on Social Media, alongside tag your friends!
                </span>
                <br>
                <div class="share-buttons">
                  <a href="https://www.facebook.com/sharer/sharer.php?u=" target="_blank"><button class="social-share"><i class="zmdi zmdi-facebook"></i></button></a>
                  <a href="https://twitter.com/intent/tweet?url=" target="_blank"><button class="social-share"><i class="zmdi zmdi-twitter"></i></button></a>
                  <a href="http://www.linkedin.com/shareArticle?mini=true&url=&title=PrepClass&source=https://www.prepclass.com.ng" target="_blank"><button class="social-share"><i class="zmdi zmdi-linkedin"></i></button></a>
                </div>
                <hr>
                <span style="font-size: 14px; margin-bottom: 10px;">Eligible for this role?</span>
                <button type="button" class="submit-button btn btn-success" @click="applyForJob">
                  Apply for this role
                  <span v-show="!applying" style="color: #ffffff;">&#x2192;</span>
                  <i class="fa fa-circle-o-notch fa-spin" v-show="applying" style="color: #ffffff;"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import swal from 'sweetalert';
import googlemapInit from '@/lib/googlemap';
import { mapState, mapGetters } from 'vuex';
import BrokenSpinner from '@/components/Preloaders/BrokenSpinner';

export default {
  name: 'tutoring-job',
  props: ['id'],
  components: {
    BrokenSpinner,
  },
  data() {
    return {
      api: `${BASE_API}/v1/tutor/tutoring-jobs/`,
      withConcerns: ['sessionClasses.subjects',
        'location',
        'sessionClasses.client',
        'sessionClasses.client.location',
        'sessionClasses.location',
        'sessionClasses.location.state',
        'sessionClasses.learners',
        'sessionClasses.learners.schoolClass',
        'sessionClasses.learners.subjects',
        'clientRequests',
        'clientLearnerRequests',
        'sessionClasses.days',
      ],
      job: {},
      verified: undefined,
      fetchingJob: true,
      loading: true,
      applying: false,
      pagination: {},
      google: undefined,
      autocomplete: undefined,
      directionsService: undefined,
      directionsDisplay: undefined,
      checking: false,
      distanceText: '',
    };
  },
  computed: {
    ...mapState('profile', ['states', 'locations']),
    ...mapGetters('profile', ['locationsByState', 'locationsByStateId', 'stateById']),
    classGroups() {
      return this.$store.getters.classgroups;
    },
    subjects() {
      return this.$store.getters.subjects;
    },
    formatedLocations() {
      if (this.state !== null) {
        const { state } = this;
        return this.locationsByStateId(state);
      }
      return this.locations;
    },
  },
  methods: {
    getJob() {
      const keyName = JSON.parse(this.$route.query.verified) === false ? this.id : this.$route.query.verified;
      const w = this.withConcerns.join(',');
      return new Promise((resolve, reject) => {
        axios.get(`${this.api}${keyName}?with=${w}`)
          .then(({ data: { data } }) => {
            this.verified = data.verified;

            if (data.verified) {
              this.job = data.jobs.find(j => j.id === parseInt(this.id, 10));
            } else {
              this.job = data.job;
            }
            resolve(data);
          })
          .catch(() => reject());
      });
    },
    applyForJob() {
      const keyName = JSON.parse(this.$route.query.verified) === false ? this.id : this.$route.query.verified;
      const param = JSON.parse(this.$route.query.verified) === false ? false : this.id;
      this.applying = true;
      console.log(keyName);
      const session_id = parseInt(keyName, 10);
      return axios.post(`${this.api}${session_id}/apply`, { verified: param })
        .then(({ data }) => {
          this.applying = false;
          swal(data.message);
        })
        .catch((error) => {
          this.applying = false;
          const { response: { data: { message, status } } } = error;
          swal({
            title: status,
            text: message,
            icon: 'error',
          });
        });
    },
    distance(lat, lng) {
      const keyName = JSON.parse(this.$route.query.verified) === false ? this.id : this.$route.query.verified;
      this.checking = false;
      return axios
        .get(`${BASE_API}/v1/global/job-distance/${keyName}?longitude=${lng}&latitude=${lat}`)
        .then(({ data: { data } }) => {
          const el = data.rows[0].elements[0];
          this.distanceText = `${el.distance.text} and would take you ${el.duration.text}`;
          this.calculateAndDisplayRoute(lat, lng);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    fillInAddress() {
      // Get the place details from the autocomplete object.
      const place = this.autocomplete.getPlace();

      const startPos = place.geometry;

      this.checking = true;

      this.distance(startPos.location.lat(), startPos.location.lng());
    },
    useGps() {
      this.checking = true;
      const geoOptions = {
        enableHighAccuracy: true,
      };

      const geoSuccess = (position) => {
        const startPos = position;
        this.distance(startPos.coords.latitude, startPos.coords.longitude);
      };

      const geoError = (error) => {
        this.checking = false;
        switch (error.code) {
          case error.TIMEOUT:
            console.log('Timeout');
            break;

          default:
            console.error(error);
            break;
        }
      };

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(geoSuccess, geoError, geoOptions);
      }
    },
    calculateAndDisplayRoute(lat, lng) {
      if (typeof this.directionsService === 'undefined') {
        return false;
      }

      if (typeof this.google === 'undefined') {
        return false;
      }

      if (typeof this.directionsDisplay === 'undefined') {
        return false;
      }

      const start = new this.google.maps.LatLng(lat, lng);

      return this.directionsService.route({
        origin: start,
        destination: this.job.address,
        travelMode: 'DRIVING',
      }, (response, status) => {
        if (status === 'OK') {
          this.directionsDisplay.setDirections(response);
        } else {
          alert(`Directions request failed due to ${status}`);
        }
      });
    },
    m(t) {
      return moment(t);
    },
    mnt(t) {
      return moment(t).format('Do MMM, YYYY');
    },
    ucfirst(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    number_format(number, decimals, dec_point, thousands_point) {
      if (number == null || !isFinite(number))
        throw new TypeError("number is not valid");

      if (!decimals) {
        var len = number.toString().split('.').length;
        decimals = len > 1 ? len : 0;
      }

      if (!dec_point)
        dec_point = '.';

      if (!thousands_point)
        thousands_point = ',';

      number = parseFloat(number).toFixed(decimals);
      number = number.replace(".", dec_point);
      var splitNum = number.split(dec_point);
      splitNum[0] = splitNum[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands_point);
      number = splitNum.join(dec_point);
      return number;
    },
  },
  mounted() {
    Promise.all([
      this.$store.dispatch('getSubjects'),
      this.$store.dispatch('getClassGroups'),
      this.$store.dispatch('profile/getStates'),
      this.$store.dispatch('profile/getLocations'),
    ])
      .then(() => {
        this.loading = false;
        this.getJob()
          .then(async () => {
            try {
              this.google = await googlemapInit();
              // Create the autocomplete object, restricting the search predictions to
              // geographical location types.
              this.autocomplete = new this.google.maps.places.Autocomplete(
                await this.$refs.autocomplete, { types: ['geocode'] },
              );

              // Avoid paying for data that you don't need by restricting the set of
              // place fields that are returned to just the address components.
              this.autocomplete.setFields(['geometry']);

              // When the user selects an address from the drop-down, populate the
              // address fields in the form.
              this.autocomplete.addListener('place_changed', this.fillInAddress);

              // Initialize the map
              this.directionsService = new this.google.maps.DirectionsService();
              this.directionsDisplay = new this.google.maps.DirectionsRenderer();

              // Crate the map
              const map = new this.google.maps.Map(await this.$refs.map, {
                zoom: 11,
                center: { lat: 6.4996018, lng: 3.3776761 },
              });


              // Display the map.
              this.directionsDisplay.setMap(map);
            } catch (e) {
              console.error(e);
            }
          })
          .catch(() => { alert('Couldn\'t load jobs! Please try again'); });
      })
      .catch(() => console.trace());
  },
};
</script>

<style type="text/css" scoped>
  * {
    color: #6b6b6b;
  }
  .ontop {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.8);
  }
  .valign-center {
    height: calc(100vh - 105px);
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -o-flex;
    display: flex;
    -webkit-flex-direction: column;
    -moz-flex-direction: column;
    -ms-flex-direction: column;
    -o-flex-direction: column;
    flex-direction: column;
    justify-content: center;
    -ms-align-items: center;
    align-items: center;
  }
  .o-6 {opacity: .6;}
  .h-200 {min-height: 200px;}
  .st {float: left; color:black; text-align: left; margin-left: 5%; margin-right: 5%;}
  .w-200 {
    background-size: cover;background-position: center; background-color: #ffffff; border-bottom: 1px solid #fefefe;
  }
  .bold {font-weight: 600;}
  .spinner {
    float: center;
    margin: 0 auto;
  }
  .hide {
    display: none !important;
  }
  .shift-sf {
    width: 50%;
    padding-left: 15px;
    padding-right: 15px;
  }
  .green-text {
    color: #639440;
    font-size: 18px;
    font-weight: 600;
  }
  #slotsLeft {
    z-index: 19; background: white; color: #333333; position: absolute; top: 0; left: 0; width: 100%; height: 100%; border-radius: .25rem; font-size: 11px; display: flex; flex-direction: row; justify-content: center; -ms-align-items: center; align-items: center; transition: all ease .3s;
  }
  .hoverableslots {
    position: relative !important; border:1px solid rgba(95, 144, 72, 0.85);
  }
  .hoverableslots #slotsLeft{
    display: none !important;
  }
  .hoverableslots:hover #slotsLeft {
    display: flex !important;
  }
  #butee {
    width: 150px;
    border: 1px solid rgba(95, 144, 72, 0.85);
    border-radius: .25rem;
    font-size: 13px;
  }
  .share-job {
    padding: 20px;
    height: 300px !important;
  }
  .student_block ul li {
    list-style-type: circle;
  }
  .mapcontain {
    padding: 0;
    border-top-left-radius: 25px;
    border-bottom-left-radius: 25px;
    overflow: hidden;
  }
  .mapactions {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    font-size: 11px;
  }
  .mapbox {
    height: 150px;
    background-image: url(./mapview.png);
    background-size: cover;
    background-repeat: no-repeat;
    background-position: bottom center;
  }
  .btn.map-button {
    width: 150px;
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -o-flex;
    display: flex;
    justify-content: center;
    -ms-align-items: center;
    align-items: center;
    height: 38px;
    background-color: #5a3880;
    color: #ffffff;
    line-height: 38px;
    padding: 0 10px;
    text-align: center;
    border-radius: 4px;
    font-size: 12px;
    vertical-align: middle;
  }
  .btn.map-button img {margin-right: 5px;}
  .btn.map-button:focus {
    outline: 0 !important;
    box-shadow: none !important;
  }
  .btn.map-button:active {box-shadow: none !important;
    background: #422661;}
  .mapinput {
    min-width: 200px;
    height: 38px;
    padding: 8px;
    font-size: 12px;
    color: rgb(107, 107, 107);
    transition: all ease 0.29s;
  }
  .mapinput:focus {min-width: 225px; outline: 0 !important; -webkit-box-shadow: none !important; box-shadow: none !important;}
  #mapkilometer {
    font-size: 14px;
    font-weight: 700;
    color: #000000;
  }

  .cta-card
  {
    border:1px solid #5e9047;
  }
  .mid-opacity {
    opacity:.8;
  }
  button, button:hover{
    outline: 0px !important;
  }
  .job-desc
  {
    padding-top: 20px;
  }
  .more-jobs
  {
    background: transparent;
    color:#5e9047;
    border-radius: 10px;
    border:2px solid #5e9047;
    height: 40px;
  }
  .social-share
  {
    margin: 5px;
    width: 40px;
    height: 40px;
    background: transparent;
    color: #5e9047;
    border: 2px solid #5e9047;
    cursor: pointer;
  }
  .social-share:hover,.more-jobs:hover{
    background: #5e9047;
    color: white;
    transition: color .3s ease-out;
  }
  .zmdi-long-arrow-right
  {
    padding-top: 5px;
    padding-right: 20px;
  }
  .card
  {
    border-radius: 0px !important;
    height: 100%;
  }
  .search_card
  {
    height: 350px;
    width: 320px;
    padding-top: 30px;
  }
  .job-content
  {
    padding: 30px;
  }
  .job-content-details
  {
    padding-top: 7px;
  }
  .job-content-header,.job-content-client
  {
    color:#5e9047;
    cursor: pointer;
  }
  .btn-amount {
    height: auto;
    background: white;
    outline: 0px;
    color: white;
    width: 120px;
    margin-top: -70px;
    right: 0;
    color: black;
    box-shadow: 10px 10px rgb(220,20,60,.3);
    border: 1px solid rgb(220,20,60);
  }
  .job-content-time
  {
    opacity: .5;
    font-weight: 600;
  }
  .btn-job
  {
    height: 40px;
    width: 70%;
  }
  .vl {
      border-left: 1px solid green;
      height: 100vh;
      margin-top: -50px;
      margin-left: 40px;
      z-index: 0;
      opacity: .2;
      margin-right: 20px;
  }
  .form-group
  {
    margin: 8px;
  }
  .search-form{
    margin-bottom: 10px;
  }
  button.btn-search
  {
    width: 100% !important;
    height: 30px;
  }
  @media only screen and (max-width: 600px) {
    .vl
    {
      display: none;
    }
    .shift-sf {
      width:117% !important;
    }
    .search_card
    {
      width: 100% !important;
    }
    .cta-card {
      padding-bottom: 20px !important;
      margin-left: -30px !important;
      width: 100% !important;
    }
    .btn-amount
    {
      height: 50px;
      font-size: 15px;
      background: transparent;
      outline: 0px;
      border:2px solid white;
      color: black;
      /* margin-top: 10px !important; */
      position:absolute;
      box-shadow: 10px 10px white;
      right:0;
      float:right;
      border: 1px solid red;
      margin-right: 10px !important;
    }
    h2.job-header{
      font-size: 20px !important;
      width:60%; line-height:1.5em; font-weight: 400;
      /* margin-top: 80px !important; */
    }
    span.naira
    {
      font-size: 15px !important;
    }
    .card
    {
      width: 90vw !important;
     margin-left: -50px;
    }
    .cta
    {
      margin-left: 20px;
    }
    .cta-card, .share-job
    {
      margin-top: 20px;
    }
    .btn-date
    {
      font-size: 15px;
      margin-bottom: 10px;
      width: 100%;
      width: 100%; border:1px solid rgba(95, 144, 72, 0.85); color:black;
      /* border: 1px solid rgba(95, 144, 72, 0.85); */
      color: black;
      background: transparent;
      text-align: left;
    }
    .share-job
    {
      height: 100% !important;
    }
  }
  </style>

<style lang="scss" scoped>
.hold {
  margin: 25px;
}
.submit-button {
  width: 100%;
  height: 38px;
  line-height: 38px;
  padding: 0 10px;
  text-align: center;
  border-radius: 4px;
  font-size: 14px;
  vertical-align: middle;
  float: right;
  color: #fff !important;
  box-shadow: 0 2px 2px 0 rgba(40, 167, 69, 0.14), 0 3px 1px -2px rgba(40, 167, 69, 0.12), 0 1px 5px 0 rgba(40, 167, 69, 0.2);
  &.btn-default {
    box-shadow: 0 2px 2px 0 rgba(112, 112, 112, 0.14), 0 3px 1px -2px rgba(112, 112, 112, 0.12), 0 1px 5px 0 rgba(112, 112, 112, 0.2);
  }
  &:focus {
    outline: 0 !important;
    box-shadow: none !important;
    &:active {box-shadow: none !important;}
  }
}

.card {
  margin-top: 10px;
  border-radius: 2px;
  box-shadow: 0 2px 2px 0 rgba(150, 150, 150, 0.14), 0 3px 1px -2px rgba(150, 150, 150, 0.12), 0 1px 5px 0 rgba(150, 150, 150, 0.2);

  .tabs {
    display: flex;
    padding: 0 40px;
    height: 48px;
    width: 100%;
    margin: 0;

    .tab {
      display: inline-block;
      text-align: center;
      line-height: 48px;
      padding: 0;
      margin: 0;
      border-bottom: 1px solid #b2b2b2;
      color: #b2b2b2;
      position: relative;
      overflow: hidden;
      cursor: pointer;

      &.router-link-exact-active {
        &::after {
          background: #639440;
          width: 100%;
          position: absolute;
          bottom: 0;
          left: 0%;
        }

        color: #333333;
      }
      // &.active { border-bottom: 2px solid #639440; }
    }
  }
}

.job_section {
  .ls {
    .top {
      height: 64px;
      display: flex;
      flex-direction: row;
      align-items: stretch;
      justify-content: flex-start;
      margin-bottom: 35px;
      .flt {
        font-size: 14px;
        font-weight: 600;
        color: rgba(77, 79, 92, 0.5);
        width: 30%;
        height: 100%;
        display: flex;
        flex-direction: row;
        cursor: pointer;
        justify-content: center;
        align-items: center;
        border-right: 1px solid rgba(112, 112, 112, 0.3);
        svg {margin-right: 5px;}
      }
      .srch {
        width: 70%;
        height: 100%;
        padding: 15px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        input {font-size: 14px; width: 165px; height: 35px;}
      }
      &:hover {.flt {color: #639440;}}
    }
    .bttm {
      width: 100%;
      padding: 25px 0;
      .form-group {
        margin-bottom: 20px;
        label {
          font-size: 13px;
          color: #639440;
          font-weight: 600;
          text-transform: uppercase;
        }
        select {
          border: 1px solid #95989A;
          border-radius: 0 !important;
          height: 42px;
          font-size: 14px;
        }
      }
    }
  }
  .rs {
    .tp {
      width: 100%;
      padding: 15px;
      position: relative;
      font-size: 22px;
      color: #576271;
      font-weight: 600;
      .sasasa {
        position: absolute;
        height: 1px;
        width: 100%;
        box-shadow: 0 3px  6px rgba(0, 0, 0, 0.16);
        background-color: #E0E3DA;
        bottom: 0;
        margin-bottom: 15px;
      }
      h4 {
        font-size: 22px;
        color: #639440;
        font-weight: 600;
        display: flex;
        flex-direction: row;
        align-items: center;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/TutoringJobs/TutoringJob.vue